import { SYSTEM_EVENT } from '../constant/actionTypes';

const getSystemEventList = (state, action) => {
  switch (action.type) {
    case SYSTEM_EVENT.DATA.INITIATE:
      return { isFetching: true, data: action.payload };
    case SYSTEM_EVENT.DATA.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SYSTEM_EVENT.DATA.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSystemEventList;
